// extracted by mini-css-extract-plugin
module.exports =  {"createGoal":"wcFPdcOYfqhLUAELzQGR"};